import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { EditViewBillDetailsComponent } from '../edit-view-bill-details/edit-view-bill-details.component';
import { MatDialog } from '@angular/material';
import { NotificationService } from 'src/@core/services/notification.service';
import { HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DeleteFileComponent } from '../delete-file/delete-file.component';
import { EmployerUploadService } from 'src/@core/services/employer/employer-upload.service';
declare var Razorpay: any;

@Component({
  selector: 'hour4u-admin-create-bill',
  templateUrl: './create-bill.component.html',
  styleUrls: ['./create-bill.component.scss']
})
export class CreateBillComponent implements OnInit {
  profile = this.appService.getCurrentAccount();
  isLoading: boolean = false;
  billingForm: FormGroup;
  roles = roles;
  entityTypes = entityTypes;
  fixedQuantityBilling: FormArray;
  selectedWorkOrders: FormArray;
  variableQuantityBilling: FormArray;
  selectedBillingData: any = null;
  selectedWorkOrdersName: string[] = [];
  selectedProjectId: any = null;
  diameter = 30;
  loaderColor: string;
  mode = 'indeterminate';
  isExporting: boolean = false;
  selectedBill: any = null;
  selectesDefaultSupportingFile: boolean = true;
  selectedFileNames: string[] = [];
  supportingFiles: FormArray;

  constructor(
    private route: ActivatedRoute,
    private appService: AppService,
    private jobService: JobService,
    private _fb: FormBuilder,
    private router: Router,
    private dialog: MatDialog,
    private notify: NotificationService,
    private employerUploadService: EmployerUploadService
  ) { }

  ngOnInit() {
    this.setInitialValues();
    this.route.params.subscribe(data => {
      this.billingForm = this._fb.group({
        selectedWorkOrders: this._fb.array([
          this.workOrderForm
        ]),
        payBefore: ['', [Validators.required]],
        isView: [false],
        supportingFiles: this._fb.array([])
      })
      this.selectedProjectId = data.id;
      this.setInitialValues();
    });
  }

  get workOrderForm() {
    return this._fb.group({
      workOrderId: [''],
      workOrderTitle: ['', [Validators.required]],
      workOrderDate: [''],
      fixedQuantityBilling: this._fb.array([
        this.rateCardForm
      ]),
      variableQuantityBilling: this._fb.array([]),
    });
  }

  get rateCardForm() {
    return this._fb.group({
      type: ['', [Validators.required]],
      description: [''],
      rate: [null],
      quantity: [null],
      isView: [false],
      // budgetFromHour4u: [null],
      // yourRate: [null],
      totalAmount: [null],
      index: []
    });
  }
  get selectedWorkOrdersFormArray() {
    return this.billingForm.get('selectedWorkOrders') as FormArray;
  }

  editBiiling() {
    this.billingForm.controls['isView'].setValue(false);
    this.selectedWorkOrders = this.billingForm.get('selectedWorkOrders') as FormArray;
    this.selectedWorkOrders.controls.forEach((ele, i) => {
      this.fixedQuantityBilling = this.selectedWorkOrders.at(i).get('fixedQuantityBilling') as FormArray;
      this.fixedQuantityBilling.controls.forEach(control => {
        control.patchValue({ isView: false });
      });

      this.variableQuantityBilling = this.selectedWorkOrders.at(i).get('variableQuantityBilling') as FormArray;
      this.variableQuantityBilling.controls.forEach(control => {
        control.patchValue({ isView: false });
      });
    })
  }

  setInitialValues() {
    this.selectedBillingData = this.jobService.getBillingData();
    if (this.selectedBillingData && this.selectedBillingData.isView) {
      this.billingForm.controls['isView'].setValue(true);
    }
    if (this.selectedBillingData) {
      this.setWorkOrderName();
      this.amountCalculationForRateCards();
    } else {
      this.notify.showMessage('Please select any workorder!', 2000);
      this.backToProjectScreen();
    }
  }

  // set Amount Calculations For Rate Cards
  amountCalculationForRateCards() {
    this.selectedWorkOrders = this.billingForm.get('selectedWorkOrders') as FormArray;
    this.selectedWorkOrders.clear();
    this.supportingFiles = this.billingForm.get('supportingFiles') as FormArray;
    this.supportingFiles.clear();
    if (this.selectedBillingData.billingData) {
      console.log(this.selectedBillingData.billingData)
      if (this.selectedBillingData.billingData && this.selectedBillingData.billingData.payBefore) {
        this.billingForm.controls['payBefore'].setValue(new Date(this.selectedBillingData.billingData.payBefore));
      }

      if (this.selectedBillingData.billingData && this.selectedBillingData.billingData.supportingFiles) {
        this.selectesDefaultSupportingFile = false;
        if (this.selectedBillingData.billingData.supportingFiles.length) {
          console.log("################################")
          this.selectedBillingData.billingData.supportingFiles.forEach(element => {
            const fileFormGroup = this._fb.group({
              key: [element.key],
              fileName: [element.fileName]
            });
            this.selectedFileNames.push(element.fileName);
            this.supportingFiles.push(fileFormGroup);
            console.log(this.supportingFiles.value)
          });
        }
      }
      this.selectedBillingData.selectedWorkOrders = this.selectedBillingData.billingData.billing;
      this.setWorkOrderName();
      this.setFixedPayAmountsAtEdit();
    } else {
      this.setFixedPayAmounts();
    }
  }

  setFixedPayAmountsAtEdit() {
    if (this.selectedBillingData.selectedWorkOrders && this.selectedBillingData.selectedWorkOrders.length) {
      this.selectedBillingData.selectedWorkOrders.forEach((order, index) => {
        this.selectedWorkOrders.push(this.workOrderForm);
        this.selectedWorkOrders.controls[index].patchValue({
          workOrderId: order.workOrderId,
          workOrderTitle: order.workOrderTitle,
          workOrderDate: order.workOrderDate
        })
      })
      this.selectedBillingData.selectedWorkOrders.forEach((order, index) => {
        let billingItems = order.fixedQuantityBilling;
        this.fixedQuantityBilling = this.selectedWorkOrders.at(index).get('fixedQuantityBilling') as FormArray;
        this.fixedQuantityBilling.clear();
        billingItems.forEach((element, i) => {
          element.workOrderDate = order.workOrderDate;
          element.workOrderTitle = order.workOrderTitle;
          this.fixedQuantityBilling.push(this.rateCardForm);
          this.fixedQuantityBilling.controls[i].patchValue({
            type: element.type,
            workOrderTitle: element.workOrderTitle,
            rate: element.rate,
            quantity: element.quantity,
            isView: this.selectedBillingData && this.selectedBillingData.isView ? true : false,
            index: index,
            budgetFromHour4u: element.rate * element.quantity,
            totalAmount: element.rate * element.quantity,
            description: element.description
          });
        });
      });

      this.selectedBillingData.selectedWorkOrders.forEach((order, index) => {
        let billingItems = order.variableQuantityBilling;
        this.variableQuantityBilling = this.selectedWorkOrders.at(index).get('variableQuantityBilling') as FormArray;
        this.variableQuantityBilling.clear();
        billingItems.forEach((element, i) => {
          element.workOrderDate = order.workOrderDate;
          element.workOrderTitle = order.workOrderTitle;
          this.variableQuantityBilling.push(this.rateCardForm);
          this.variableQuantityBilling.controls[i].patchValue({
            type: element.type,
            workOrderTitle: element.workOrderTitle,
            rate: element.rate,
            quantity: element.quantity,
            isView: this.selectedBillingData && this.selectedBillingData.isView ? true : false,
            index: index,
            budgetFromHour4u: element.rate * element.quantity,
            totalAmount: element.rate * element.quantity,
            description: element.description
          });
        });
      });
    }
  }

  // set Fixed Pay Amounts
  setFixedPayAmounts() {
    if (this.selectedBillingData.selectedWorkOrders && this.selectedBillingData.selectedWorkOrders.length) {
      this.selectedBillingData.selectedWorkOrders.forEach((order, index) => {
        this.selectedWorkOrders.push(this.workOrderForm);
        this.selectedWorkOrders.controls[index].patchValue({
          workOrderId: order.id,
          workOrderTitle: order.workOrderTitle ? order.workOrderTitle : order.venue.name,
          workOrderDate: order.dates[0].date
        })
      })
      this.selectedBillingData.selectedWorkOrders.forEach((order, index) => {
        let billingItems = order.billingItems;
        this.fixedQuantityBilling = this.selectedWorkOrders.at(index).get('fixedQuantityBilling') as FormArray;
        this.fixedQuantityBilling.clear();
        billingItems.forEach((element, i) => {
          element.workOrderDate = order.dates[0].date;
          element.workOrderTitle = order.workOrderTitle ? order.workOrderTitle : order.venue.name;
          this.fixedQuantityBilling.push(this.rateCardForm);
          this.fixedQuantityBilling.controls[i].patchValue({
            type: element.type,
            workOrderTitle: element.workOrderTitle,
            rate: element.rate,
            quantity: element.quantity,
            isView: this.selectedBillingData && this.selectedBillingData.isView ? true : false,
            index: index,
            budgetFromHour4u: element.rate * element.quantity,
            totalAmount: element.rate * element.quantity
          });
        });
      });

      this.selectedBillingData.selectedWorkOrders.forEach((order, index) => {
        console.log(order)
        let variableBillingItems = order.variableBillingItems;
        this.variableQuantityBilling = this.selectedWorkOrders.at(index).get('variableQuantityBilling') as FormArray;
        this.variableQuantityBilling.clear();
        variableBillingItems.forEach((element, i) => {
          element.workOrderDate = order.dates[0].date;
          element.workOrderTitle = order.workOrderTitle ? order.workOrderTitle : order.venue.name;
          this.variableQuantityBilling.push(this.rateCardForm);
          this.variableQuantityBilling.controls[i].patchValue({
            type: element.type,
            workOrderTitle: element.workOrderTitle,
            rate: element.rate,
            quantity: i == 0 ? (order.approvedTaskCount ? order.approvedTaskCount : (order.taskCount ? order.taskCount : 0)) : element.quantity,
            isView: this.selectedBillingData && this.selectedBillingData.isView ? true : false,
            index: index,
            budgetFromHour4u: element.rate * (i == 0 ? (order.approvedTaskCount ? order.approvedTaskCount : (order.taskCount ? order.taskCount : 0)) : element.quantity),
            totalAmount: element.rate * (i == 0 ? (order.approvedTaskCount ? order.approvedTaskCount : (order.taskCount ? order.taskCount : 0)) : element.quantity)
          });
        });
      });
    }
  }

  // set selected Work Orders Name
  setWorkOrderName() {
    this.selectedWorkOrdersName = [];
    if (this.selectedBillingData && this.selectedBillingData.selectedWorkOrders && this.selectedBillingData.selectedWorkOrders.length) {
      this.selectedWorkOrdersName = this.selectedBillingData.selectedWorkOrders.map(shift => shift.workOrderTitle ? shift.workOrderTitle : (shift.venue && shift.venue.name ? shift.venue.name : ""));
    }
  }

  displayVenueNames(): string {
    const maxDisplayCount = 2;
    const displayedNames = this.selectedWorkOrdersName.slice(0, maxDisplayCount).join(', ');

    if (this.selectedWorkOrdersName.length > maxDisplayCount) {
      const remainingCount = this.selectedWorkOrdersName.length - maxDisplayCount;
      return `${displayedNames}, and ${remainingCount} more`;
    } else {
      return displayedNames;
    }
  }

  // get Total Proposed Billing
  getTotalProposedBilling() {
    this.selectedWorkOrders = this.billingForm.get('selectedWorkOrders') as FormArray;
    let totalBilling = 0;
    this.selectedWorkOrders.controls.forEach((ele, i) => {
      this.fixedQuantityBilling = this.selectedWorkOrders.at(i).get('fixedQuantityBilling') as FormArray;
      if (this.fixedQuantityBilling.value.length) {
        this.fixedQuantityBilling.value.forEach(element => {
          totalBilling = totalBilling + (element.totalAmount);
        });
      }

      this.variableQuantityBilling = this.selectedWorkOrders.at(i).get('variableQuantityBilling') as FormArray;
      if (this.variableQuantityBilling.value.length) {
        this.variableQuantityBilling.value.forEach(element => {
          totalBilling = totalBilling + (element.quantity * element.rate);
        });
      }
    });
    return totalBilling;
  }

  // get Total Billing's 18% GST
  applicableGSTForProposedAmount() {
    this.selectedWorkOrders = this.billingForm.get('selectedWorkOrders') as FormArray;
    let totalBilling = 0;
    this.selectedWorkOrders.controls.forEach((ele, i) => {
      this.fixedQuantityBilling = this.selectedWorkOrders.at(i).get('fixedQuantityBilling') as FormArray;
      if (this.fixedQuantityBilling.value.length) {
        this.fixedQuantityBilling.value.forEach(element => {
          totalBilling = totalBilling + (element.totalAmount);
        });
      }

      this.variableQuantityBilling = this.selectedWorkOrders.at(i).get('variableQuantityBilling') as FormArray;
      if (this.variableQuantityBilling.value.length) {
        this.variableQuantityBilling.value.forEach(element => {
          totalBilling = totalBilling + (element.quantity * element.rate);
        });
      }
    });
    return totalBilling * 0.18;
  }

  // get Total final Billing with 18% GST
  getTotalFinalBillingForProposedAmount() {
    this.selectedWorkOrders = this.billingForm.get('selectedWorkOrders') as FormArray;
    let totalBilling = 0;
    this.selectedWorkOrders.controls.forEach((ele, i) => {
      this.fixedQuantityBilling = this.selectedWorkOrders.at(i).get('fixedQuantityBilling') as FormArray;
      if (this.fixedQuantityBilling.value.length) {
        this.fixedQuantityBilling.value.forEach(element => {
          totalBilling = totalBilling + (element.totalAmount);
        });
      }

      this.variableQuantityBilling = this.selectedWorkOrders.at(i).get('variableQuantityBilling') as FormArray;
      if (this.variableQuantityBilling.value.length) {
        this.variableQuantityBilling.value.forEach(element => {
          totalBilling = totalBilling + (element.quantity * element.rate);
        });
      }
    });
    return totalBilling * 1.18;
  }

  // add more work pictures fields
  addMoreWorkRateCardFields(index) {
    this.selectedWorkOrders = this.billingForm.get('selectedWorkOrders') as FormArray;
    this.fixedQuantityBilling = this.selectedWorkOrders.at(index).get('fixedQuantityBilling') as FormArray;
    this.fixedQuantityBilling.push(this.rateCardForm);
  }

  // add more work pictures fields
  addMoreVariableRateCardFields(index) {
    this.selectedWorkOrders = this.billingForm.get('selectedWorkOrders') as FormArray;
    this.variableQuantityBilling = this.selectedWorkOrders.at(index).get('variableQuantityBilling') as FormArray;
    this.variableQuantityBilling.push(this.rateCardForm);
  }

  // Delete picture fields
  deleteRateCardField(j, index) {
    this.selectedWorkOrders = this.billingForm.get('selectedWorkOrders') as FormArray;
    this.fixedQuantityBilling = this.selectedWorkOrders.at(j).get('fixedQuantityBilling') as FormArray;
    this.fixedQuantityBilling.removeAt(index);
  }

  deleteVariableRateCardField(j, index) {
    this.selectedWorkOrders = this.billingForm.get('selectedWorkOrders') as FormArray;
    this.variableQuantityBilling = this.selectedWorkOrders.at(j).get('variableQuantityBilling') as FormArray;
    this.variableQuantityBilling.removeAt(index);
  }

  // approve/reject Project
  changeBillingStatus(data, status) {
    this.jobService.updateBillingStatus(data.id, status).subscribe(res => {
      this.backToProjectScreen();
      this.notify.showMessage('Bill Status Updated Successfully!', 2000);
    }, ((err: any) => {
      this.notify.showMessage(err.error.message, 2000);
    }))
  }

  sendBill(isDraft?: boolean) {
    this.supportingFiles = this.billingForm.get('supportingFiles') as FormArray;
    if (this.billingForm.valid) {
      let workOrderList = [];
      this.selectedBillingData.selectedWorkOrders.forEach(element => {
        if (element.id) {
          workOrderList.push(element.id);
        }
        if (element.workOrderId) {
          workOrderList.push(element.workOrderId);
        }
      });

      const dateString = this.billingForm.value.payBefore;
      const dateObj = new Date(dateString);
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1;
      const day = dateObj.getDate();
      let supportingFiles = [];
      if (this.supportingFiles.value && this.supportingFiles.value.length && !this.selectesDefaultSupportingFile) {
        supportingFiles = this.supportingFiles.value
      } else {
        if (this.selectesDefaultSupportingFile) {
          supportingFiles = [
            {
              key: "Supporting excel.xlsx",
              fileName: "Supporting excel.XLS"
            }
          ]
        }
      }
      const resultArray: number[] = [year, month, day];
      let obj = {
        "jobId": this.selectedBillingData.id,
        "title": this.selectedBillingData.billingTitle,
        "workOrderList": workOrderList,
        "billing": this.billingForm.value.selectedWorkOrders,
        "status": isDraft ? "DRAFT" : "APPROVAL_PENDING",
        "billingAmount": this.getTotalProposedBilling(),
        "gstAmount": this.applicableGSTForProposedAmount(),
        "totalAmount": this.getTotalFinalBillingForProposedAmount(),
        "payBefore": resultArray,
        "supportingFiles": supportingFiles
      }

      if (this.selectedBillingData.billingData && this.selectedBillingData.billingData.id) {
        this.jobService.updateBill(obj, this.selectedBillingData.billingData.id).subscribe(res => {
          this.backToProjectScreen();
          this.notify.showMessage('Billing updated successfully!', 2000);
        }, ((err: any) => {
          this.notify.showMessage(err.error.message, 2000);
        }))
      } else {
        this.jobService.createBill(obj).subscribe(res => {
          this.backToProjectScreen();
          this.notify.showMessage('Billing created successfully!', 2000);
        }, ((err: any) => {
          this.notify.showMessage(err.error.message, 2000);
        }))
      }
    } else {
      this.notify.showMessage('Please enter all require details!', 2000);
      this.billingForm.markAllAsTouched();
      return;
    }
  }

  // added Propose dRate
  addedProposedRate(j, index) {
    this.selectedWorkOrders = this.billingForm.get('selectedWorkOrders') as FormArray;
    this.fixedQuantityBilling = this.selectedWorkOrders.at(j).get('fixedQuantityBilling') as FormArray;
    this.fixedQuantityBilling.value.forEach((element, i) => {
      if (index == i) {
        this.fixedQuantityBilling.controls[i].get('totalAmount').setValue(element.quantity * element.rate);
      }
    })
  }

  addedProposedRateForVariablePay(j, index) {
    this.selectedWorkOrders = this.billingForm.get('selectedWorkOrders') as FormArray;
    this.variableQuantityBilling = this.selectedWorkOrders.at(j).get('variableQuantityBilling') as FormArray;
    this.variableQuantityBilling.value.forEach((element, i) => {
      if (index == i) {
        this.variableQuantityBilling.controls[i].get('totalAmount').setValue(element.quantity * element.rate);
      }
    })
  }

  jobDateChange(event) {
  }

  editBillTitle() {
    let obj = Object.assign({}, this.selectedBillingData);
    obj.updateTitleOnly = true;
    obj.viewSeletedWorkOrdersOnly = false;
    obj.actionTitle = "Edit bill name";

    const dialogRef = this.dialog.open(EditViewBillDetailsComponent, {
      width: '500px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      data: obj,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.setInitialValues();
      }
    });
  }

  viewSelectedWorkOrders() {
    let obj = Object.assign({}, this.selectedBillingData);
    obj.viewSeletedWorkOrdersOnly = true;
    obj.updateTitleOnly = false;
    obj.creteBilling = false;
    obj.actionTitle = obj.billingTitle;

    const dialogRef = this.dialog.open(EditViewBillDetailsComponent, {
      width: '400px',
      // panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      data: obj,
      autoFocus: true,
      position: { top: '0px' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  addMore() {
    // alert("Coming Soon...")
    this.router.navigateByUrl('/job/view/' + this.selectedProjectId);
  }

  backToProjectScreen() {
    this.router.navigateByUrl('/job/view/' + this.selectedProjectId);
  }

  downloadSupportingExcel(index?: number) {
    if (index) {
      let params = new HttpParams();
      if (Array.isArray(this.selectedBillingData.selectedWorkOrders)) {
        this.selectedBillingData.selectedWorkOrders.forEach(workorder => {
          if (workorder.id) {
            params = params.append('id', workorder.id);
          }
          if (workorder.workOrderId) {
            params = params.append('id', workorder.workOrderId);
          }
        });
      }
      this.isExporting = true;
      this.jobService.exportBillingData(params).subscribe(res => {
        this.isExporting = false;
        // Handle the API response, which is a file to download
        const blob = new Blob([res.body!], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);

        // Create a link element and trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Supporting excel.xlsx'; // specify the desired filename here
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      }, (err => {
        this.isExporting = false;
      }))
    } else {



    }
  }

  // Payment options
  razorPayOptions = {
    "key": '',
    "amount": 0,
    "currency": '',
    "name": '',
    "discription": "Workorbit's Billing",
    "order_id": '',
    "handler": (response) => {
      this.jobService.updateBillingStatus(this.selectedBill.billingData.id, 'PAYMENT_SUCCESS').subscribe(res => {
        this.notify.showMessage('Billing paid successfully!', 2000);
        this.selectedBillingData.billingData.status = "PAYMENT_SUCCESS";
        this.jobService.saveBillingData(this.selectedBillingData);
        this.setInitialValues();
        this.selectedBill = null;
      }, ((err: any) => {
        this.notify.showMessage(err.error.message, 2000);
      }))
    }
  };

  // Pay Bill
  payBill(row: any) {
    this.selectedBill = row;
    this.razorPayOptions.amount = row.billingData.totalAmount
    this.razorPayOptions.currency = 'INR';
    this.razorPayOptions.key = environment.rezorpayKey;
    this.razorPayOptions.order_id = row.billingData.paymentDetails.razorPayOrderId;
    var rzp = new Razorpay(this.razorPayOptions);
    rzp.open()
    rzp.on('payment.failed', function (response) {
      alert(response.error.code);
      alert(response.error.description);
      alert(response.error.source);
      alert(response.error.step);
      alert(response.error.reason);
      alert(response.error.metadata.order_id);
      alert(response.error.metadata.payment_id);
    });
  }

  deleteFile() {
    const dialogRef = this.dialog.open(DeleteFileComponent, {
      width: '500px',
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      // data: obj,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectesDefaultSupportingFile = false;
      }
    });
  }

  onFileSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      this.supportingFiles = this.billingForm.get('supportingFiles') as FormArray;
      this.isLoading = true;

      for (let i = 0; i < inputElement.files.length; i++) {
        const file = inputElement.files[i];

        // Upload the file to S3 using the existing function
        this.employerUploadService.uploadProfileImage(file).subscribe(
          (s3File) => {
            console.log('File uploaded successfully:', s3File);
            const fileFormGroup = this._fb.group({
              key: [s3File.key, Validators.required], // Assuming 'key' is required
              fileName: [file.name, Validators.required] // Assuming 'fileName' is required
            });
            this.isLoading = false;
            this.supportingFiles.push(fileFormGroup);
            console.log(this.supportingFiles)
            this.selectedFileNames.push(file.name);
          },
          (error) => {
            this.isLoading = true;
            console.error('Error uploading file:', error);
          }
        );
      }
    }
  }

  deleteSelectedFile(index) {
    console.log(index)
    const supportingFiles = this.billingForm.get('supportingFiles') as FormArray;
    console.log(supportingFiles)
    this.supportingFiles.removeAt(index);
  }

  get supportingFilesArrayForm() {
    return this.billingForm.get('supportingFiles') as FormArray;
  }

  ngOnDestroy() {
    this.jobService.clearBillingData();
  }
}
